<template>
  <v-container fluid class="full-container d-flex flex-column">
    <v-card class="pa-4">
      <v-row>
        <v-col cols="12" class="my-1 py-0">
          <span class="mx-2 font-weight-bold"> Open Tasks: {{ openTasks }} </span>
        </v-col>

        <v-col cols="6" class="my-1 py-0">
          <v-checkbox v-model="filters.closedAt_Isnull" label="Hide Completed" />
        </v-col>

        <v-col cols="6" class="my-1 py-0">
          <div class="d-block">
            <v-label><span class="ml-1">Assigned To</span></v-label>
            <v-autocomplete
              v-model="filters.assignedToId_In"
              class="ml-2 pt-1"
              item-text="name"
              item-value="id"
              label="Assigned to"
              placeholder="Assigned To"
              clearable
              dense
              filled
              outlined
              small-chips
              solo
              rounded
              multiple
              :disabled="$store.getters.isContractor"
              :items="users"
            >
              <template v-slot:selection="data">
                <v-chip v-bind="data.attrs" :input-value="data.selected">
                  <v-avatar left>
                    <v-img :src="data.item.avatar" />
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <v-img :src="data.item.avatar" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name" />
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
        </v-col>
      </v-row>

      <hr />
      <v-row>
        <v-col cols="12" class="my-1 py-0">
          <div class="text-right mb-5 mt-4 ">
            <v-btn color="primary" @click="showAction = true" class="mr-2">Actions</v-btn>
            <v-btn color="primary" @click="showFilter = true" class="mr-2">Additional Filters</v-btn>
            <v-btn color="primary" @click="showTaskForm = true">Create New Task</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mt-3">
      <v-row>
        <v-col :cols="selectedSidebarClient ? 8 : 12">
          <v-data-table
            v-model="selectedDataTable"
            :loading="$apollo.queries.taskEvents.loading"
            :headers="table.headers"
            item-key="id"
            :items-per-page="filters.first"
            :items="tableData"
            show-expand
            show-select
            hide-default-footer
            dense
            :single-expand="true"
            :expanded.sync="table.expanded"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="ma-0 pa-0">
                <v-card class="ma-1 pa-0" elevation="5">
                  <v-row>
                    <v-col cols="12" class="py-2">
                      <div class="d-flex justify-space-between">
                        <v-card-title class="pa-2">{{ item.title }}</v-card-title>
                        <resolve-message-btn v-if="item.chat" :chat="item.chat" :resolved="false" class="mr-2" />
                      </div>
                      <v-card-text class="px-2 py-0">
                        <div v-html="item.description" />
                        <div v-if="item.item.reporter" class="font-weight-bold mt-2">
                          Reported by: {{ item.item.reporter.firstName }} {{ item.item.reporter.lastName }}
                        </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <task-attachment class="pa-5" :taskId="item.id" :attachments="item.item.taskeventattachmentSet" />
                    </v-col>
                    <v-col cols="6">
                      <task-comment class="pa-5 pr-2" :taskId="item.id" />
                    </v-col>
                  </v-row>
                </v-card>
              </td>
            </template>
            <template v-slot:item.title="{ item }">
              <a :href="`/task/${item.id}`" target="_blank">{{ item.title }}</a>
              <span style="font-size:11px;">- ({{ item.item.taskType.title }})</span>
            </template>
            <template v-slot:item.user="{ item }">
              <a @click="toggleSideBar(item)">{{ item.user }}</a>
            </template>
            <template v-slot:item.assignedTo="{ item }">
              <v-autocomplete
                :key="'deal-owner-' + item.id"
                :value="assignedTo(item.item.assignedTo)"
                dense
                :items="
                  users.map((element) => {
                    return { text: element.name, value: element.id };
                  })
                "
                class="pa-0"
                @input="setAssignee($event, item)"
              />
            </template>
            <template v-slot:item.stage="{ item }">
              <v-select
                :key="'stage-' + item.id"
                :value="item.stage"
                :items="taskStages"
                class="pa-0"
                @input="setStage($event, item)"
              />
            </template>
          </v-data-table>
          <node-paginator
            :per-page="filters.first"
            :total-entries="numberOfRecords"
            :current-page="Math.floor(filters.offset / filters.first) + 1"
            @page-change="goToPage"
          />
        </v-col>
        <v-col v-if="selectedSidebarClient" cols="4">
          <client-summary :user-id="selectedSidebarClient" />
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="showTaskForm"
      persistent
      class="limited-height"
      width="900"
      transition="dialog-bottom-transition"
    >
      <task-form @close="showTaskForm = false" @created="refetch()" />
    </v-dialog>

    <v-dialog v-model="showFilter" persistent class="limited-height" width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>
            Filter
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showFilter = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="w-100 mr-2">
                <v-select
                  v-model="filters.taskType_Id_In"
                  :items="taskTypes"
                  label="Task types"
                  single-line
                  dense
                  chips
                  multiple
                />
              </div>
              <div class="w-100">
                <user-search @user-selected="selectedUser = $event" />
              </div>

              <div class="d-flex">
                <v-menu
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :close-on-content-click="false"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.createdAt_Gte"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Tasks Created From"
                      prepend-icon="mdi-calendar"
                    />
                  </template>
                  <v-date-picker v-model="filters.createdAt_Gte"></v-date-picker>
                </v-menu>
                <v-menu
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :close-on-content-click="false"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.createdAt_Lte"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      label="Tasks Created To"
                      prepend-icon="mdi-calendar"
                    />
                  </template>
                  <v-date-picker v-model="filters.createdAt_Lte"></v-date-picker>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAction" persistent class="limited-height" width="900" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>
            Actions
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showAction = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="d-block">
                <div class="v-card__title">Update Stage/Assignee</div>
                <div class="d-flex">
                  <div class="w-100">
                    <v-label><span class="ml-1">Stage</span></v-label>
                    <v-autocomplete
                      v-model="selectedStage"
                      class="ml-2 pt-1"
                      item-text="text"
                      item-value="value"
                      label="Stage"
                      placeholder="Stage"
                      clearable
                      dense
                      filled
                      outlined
                      small-chips
                      solo
                      rounded
                      :disabled="selectedDataTable.length === 0"
                      :items="taskStages"
                      @input="setAllStage($event)"
                    />
                  </div>
                  <div class="w-100">
                    <v-label><span class="ml-1">Assignee</span></v-label>
                    <v-autocomplete
                      v-model="selectedAssignee"
                      class="ml-2 pt-1"
                      item-text="name"
                      item-value="id"
                      label="Assignee"
                      placeholder="Assignee"
                      clearable
                      dense
                      filled
                      outlined
                      small-chips
                      solo
                      rounded
                      :disabled="selectedDataTable.length === 0"
                      :items="users"
                      @input="setAllAssignee($event)"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { STAGES_QUERY, TASK_EVENT_QUERY, TASK_TYPE_QUERY } from "@/graphql/queries/task";
import { UPSERT_TASK_EVENT_MUTATION, UPSERT_MULTI_TASK_EVENT_MUTATION } from "@/graphql/mutations/task";
import { extractNodes } from "@/lib/array";
import { STAFF_QUERY } from "@/graphql/queries/user";
import { decodeId, IdToNode } from "@/lib/string";
import { getUserName } from "@/lib/username";
import TaskComment from "@/components/task/components/TaskComment";
import TaskAttachment from "@/components/task/components/TaskAttachment";
import ClientSummary from "@/components/task/components/ClientSummary";
import NodePaginator from "@/components/shared/NodePaginator";
import TaskForm from "@/components/task/components/TaskForm";
import ResolveMessageBtn from "@/components/dashboard/components/columns/ResolveMessage";

import UserSearch from "@/components/client/blocks/UserSearch";
export default {
  name: "TaskList",
  components: {
    ClientSummary,
    TaskComment,
    TaskAttachment,
    NodePaginator,
    TaskForm,
    ResolveMessageBtn,
    UserSearch,
  },
  data() {
    return {
      users: [],
      numberOfRecords: 0,
      selectedSidebarClient: null,
      taskTypes: [],
      taskStages: [],
      table: {
        expanded: [],
        headers: [
          { text: "Date", value: "date" },
          { text: "User", value: "user" },
          { text: "Title", value: "title" },
          { text: "Assigned To", value: "assignedTo" },
          { text: "Stage", value: "stage" },
          { text: "Completed Date", value: "closedAt" },
        ],
      },
      filters: {
        first: 20,
        offset: 0,
        taskType_Id_In: [],
        orderBy: "-createdAt",
        closedAt_Isnull: true,
        assignedToId_In: [decodeId(this.$store.getters.user.id)],
        userId: null,
        createdAt_Gte: null,
        createdAt_Lte: null,
      },
      showTaskForm: false,
      showFilter: false,
      showAction: false,
      selectedStage: null,
      selectedAssignee: null,
      selectedDataTable: [],
      selectedUser: null,
    };
  },
  computed: {
    tableData() {
      if (!this.taskEvents) return [];
      let taskEvents = this.taskEvents;

      if (this.filters.assignedToId_In.length === 0 && !this.filters.userId) {
        taskEvents = taskEvents.filter((x) => !x.assignedTo || x.assignedTo === "");
      }

      return taskEvents;
    },
  },
  watch: {
    selectedUser(val) {
      this.filters.userId = val;
    },
    tableData(item) {
      if (this.filters.assignedToId_In.length === 0) {
        this.numberOfRecords = item.length;
      }
      this.selectedDataTable = [];
    },
  },
  methods: {
    async setAllAssignee(assignedTo) {
      await this.updateMultiTask({
        taskEventIds: this.selectedDataTable.map((x) => decodeId(x.id)),
        data: { assignedTo },
      });

      this.showSuccessMessage("Task assigned");
      this.$apollo.queries.taskEvents.refetch();

      setTimeout(() => {
        this.selectedAssignee = null;
        this.selectedDataTable = [];
        this.showFilter = false;
        this.showAction = false;
      }, 1000);
    },
    async setAllStage(stageId) {
      await this.updateMultiTask({
        taskEventIds: this.selectedDataTable.map((x) => decodeId(x.id)),
        data: { stageId },
      });

      this.showSuccessMessage("Stage updated");
      this.$apollo.queries.taskEvents.refetch();

      setTimeout(() => {
        this.selectedStage = null;
        this.selectedDataTable = [];
        this.showFilter = false;
        this.showAction = false;
      }, 1000);
    },
    assignedTo(item) {
      return item ? item.id : null;
    },
    async updateTask(item) {
      return await this.$apollo.mutate({
        mutation: UPSERT_TASK_EVENT_MUTATION,
        variables: item,
      });
    },
    async updateMultiTask(item) {
      return await this.$apollo.mutate({
        mutation: UPSERT_MULTI_TASK_EVENT_MUTATION,
        variables: item,
      });
    },
    toggleSideBar(item) {
      if (this.selectedSidebarClient !== item.item.user.id) this.selectedSidebarClient = item.item.user.id;
      else this.selectedSidebarClient = null;
    },
    async setStage(stageId, item) {
      const result = await this.updateTask({
        taskEventId: decodeId(item.id),
        data: {
          stageId: stageId,
        },
      });
      if (result.data.upsertTaskEvent.updated) this.showSuccessMessage("Stage updated");
      this.$apollo.queries.taskEvents.refetch();
    },
    async setAssignee(assignedTo, item) {
      const result = await this.updateTask({
        taskEventId: decodeId(item.id),
        data: {
          assignedTo: assignedTo,
        },
      });
      if (result.data.upsertTaskEvent.updated) this.showSuccessMessage("Task assigned");
      this.$apollo.queries.taskEvents.refetch();
    },
    showSuccessMessage(message) {
      this.$toasted.success(message, {
        duration: 2000,
        position: "bottom-center",
      });
    },
    goToPage(page) {
      this.filters.offset = (page - 1) * this.filters.first;
    },
  },
  apollo: {
    taskTypes: {
      query: TASK_TYPE_QUERY,
      fetchPolicy: "cache-and-network",
      update({ taskTypes }) {
        return taskTypes.map((x) => ({
          text: x.title,
          value: x.id,
        }));
      },
    },
    taskStages: {
      query: STAGES_QUERY,
      fetchPolicy: "cache-and-network",
      update({ stages }) {
        return stages.map((x) => ({
          text: x.title,
          value: x.id,
        }));
      },
    },
    openTasks: {
      query: TASK_EVENT_QUERY,
      variables() {
        return {
          first: 0,
          assignedToId_In: this.filters.assignedToId_In,
          closedAt_Isnull: true,
        };
      },
      update(data) {
        return data.taskEvents.totalCount;
      },
    },
    taskEvents: {
      query: TASK_EVENT_QUERY,
      fetchPolicy: "cache-and-network",
      pollInterval: 60 * 1000,
      variables() {
        const data = JSON.parse(JSON.stringify(this.filters));
        data.createdAt_Gte = data.createdAt_Gte ? new Date(data.createdAt_Gte) : null;
        data.createdAt_Lte = data.createdAt_Lte ? new Date(data.createdAt_Lte) : null;
        data.userId = data.userId ? btoa("UserNode:" + data.userId) : null;
        data.assignedToId_Isnull = data.assignedToId_In.length === 0;
        if (!data["closedAt_Isnull"]) data["closedAt_Isnull"] = null;
        return data;
      },
      update({ taskEvents }) {
        this.numberOfRecords = taskEvents.totalCount;

        return extractNodes(taskEvents.edges).map((x) => ({
          id: x.id,
          title: x.title,
          assignedTo: x.assignedTo ? `${x.assignedTo.firstName} ${x.assignedTo.lastName}` : "",
          stage: x.stage.id,
          stageTitle: x.stage.title,
          user: x.user ? `${x.user.firstName} ${x.user.lastName}` : "",
          date: x.taskEventDate,
          closedAt: x.closedAt ? this.$moment(new Date(x.closedAt)).format("YYYY-MM-DD") : null,
          description: x.description,
          item: x,
          chat: x.user ? x.user.userProfile.coachingChat : null,
        }));
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      update(response) {
        return extractNodes(response.users.edges)
          .map((x) => ({
            id: decodeId(x.id),
            name: getUserName(x),
            avatar: x.userProfile?.profilePicture,
          }))
          .sort((a, b) => (a.name > b.name ? 1 : -1));
      },
    },
  },
};
</script>
<style scoped>
.w-100 {
  width: 100%;
}
</style>
